// import BoldImg from "../../assests/mobileHIW.svg";
import { motion } from "framer-motion";
import useStyles from "../../pages/HowitWorks/styles";
import { useRef, useEffect } from "react";
import { Grid } from "@mui/material";
import Navbar from "../../component/Navbar/NavBar";
import Footer from "../../Footer/Footer";
import Cardinal from "../../assests/cardinalimg.svg";

const AboutUs = () => {
  const classes = useStyles();
  const FooterRef = useRef(null);
  const FAQRef = useRef(null);
  const HowitworksRef = useRef(null);
  const AboutRef = useRef(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Navbar
        FooterRef={FooterRef}
        HowitworksRef={HowitworksRef}
        AboutRef={AboutRef}
        FAQRef={FAQRef}
      />
      <div className={classes.root}>
        <div className={classes.margincont}>
          <div className={classes.container}>
            <div className={classes.itemWrapper}>
              <Grid
                container
                spacing={{ xs: 0, sm: 0 }}
                sx={{
                  maxWidth: "1420px",
                  margin: "0 auto",
                //   paddingInline: "58px",
                  justifyContent: "center",
                  "@media (max-width:500px)": {
                    paddingInline: "1rem",
                  },
                }}
              >
                <Grid item xs={12} sm={12} md={6} lg={8}>
                  <motion.div
                    className={classes.imgcard}
                    whileHover={{
                      y: -10,
                      scale: 1.03,
                      transition: { duration: 0.3, ease: "easeInOut" },
                    }}
                  >
                    <div className={classes.forcardinal}>
                      <img src={Cardinal} alt="cardinal-img" />
                    </div>
                  </motion.div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <motion.div
                    className={classes.rightcard}
                    whileHover={{
                      y: -10,
                      scale: 1.03,
                      transition: { duration: 0.3, ease: "easeInOut" },
                    }}
                  >
                    <div className={classes.principle}>
                      <div className={classes.secondsection}>
                        <h2>About us</h2>
                      </div>
                      <div>
                        <div className={classes.feature}>
                          <h3>Friends</h3>
                          <p>
                            The journey to SLOT Finance began with a simple
                            frustration waiting for funds to accumulate before
                            taking action on time sensitive projects. Our
                            founder, tired of these delays, envisioned a better
                            way to pool and rotate money amongst friends.
                            Traditional Ajo systems weren’t built for
                            flexibility, so he created one that is modern,
                            digital, and designed around trust.
                          </p>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <motion.div
                    className={classes.bottomcard}
                    whileHover={{
                      y: -10,
                      scale: 1.03,
                      transition: { duration: 0.3, ease: "easeInOut" },
                    }}
                  >
                    <div className={classes.principle}>
                      <div className={classes.secondsection}>
                        <h2>Trusted By Group of Friends.</h2>
                      </div>
                      <div>
                        <div className={classes.feature}>
                          <p>
                            This is what people are saying after having used
                            SLOT finance with their community of friends. You
                            can be the next to say something nice.
                          </p>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </div>
      <div ref={FooterRef}>
        <Footer />
      </div>
    </>
  );
};

export default AboutUs;
